module.exports = __webpack_public_path__ + "img/ghana.a0f1799c.jpg";